import WMUUtils from "../../wmu-utils/src";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class PositionManager {

	/**
	 * 
	 * @type PositionEntity[]
	 */
	entityList = [];

	/**
	 * 
	 * @type Number
	 */
	intervalId = undefined;

	/**
	 * 
	 * @type Number
	 */
	lastWindowWidth = undefined;

	/**
	 * 
	 * @type Boolean
	 */
	isFirstWatcherUpdate = true;

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}
	
	/**
	 * 
	 */
	init()
	{
		this.onDOMContentLoaded = this.onDOMContentLoaded.bind( this );
		document.addEventListener( 'DOMContentLoaded', this.onDOMContentLoaded );

		this.onWatcherInterval = this.onWatcherInterval.bind( this );

		this.onWindowResize = this.onWindowResize.bind( this );
		window.addEventListener( 'resize', this.onWindowResize );
	}

	/**
	 * 
	 * @param {HTMLElement} element 
	 * @param {Object} args 
	 */
	add( element, args )
	{
		if ( -1 === this.getElementIndex( element ) )
		{
			this.entityList.push( new PositionEntity( element, args ) );
		}
	}

	/**
	 * 
	 * @param {HTMLElement} parentElement 
	 */
	addFrom( parentElement )
	{
		const currentViewport = ViewportManager.getCurrentViewport();

		/**
		 * Searching for menu-item inner menu in expand display mode
		 */
		parentElement.querySelectorAll( `.menu-item[${currentViewport}-menu-display="expand"].has-menu > .menu-inner` ).forEach( ( element ) =>
		{
			this.add( element, { x: 'center' } );
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	getElementIndex( element )
	{
		let index = -1;

		for ( let i = 0, c = this.entityList.length; i < c; i++ )
		{
			if ( element === this.entityList[i].element ) return i;
		}

		return index;
	}

	/**
	 * 
	 */

	/**
	 * 
	 */
	update()
	{
		this.entityList.forEach( ( entity ) =>
		{
			entity.update();
			// entity.element.classList.add( "pos-ready" );

			// console.log( "pos-ready", entity );
		} );

		this.lastWindowWidth = window.innerWidth;
	}

	/**
	 * 
	 */
	watcherStart()
	{
		this.intervalId = setInterval( this.onWatcherInterval, 500 );
	}

	/**
	 * 
	 */
	watcherStop()
	{
		if ( undefined !== this.intervalId )
		{
			clearInterval( this.intervalId );
			this.intervalId = undefined;
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onDOMContentLoaded( event )
	{
		if ( this.lastWindowWidth !== window.innerWidth )
		{
			this.addFrom( document );
			this.update();
			this.watcherStart();
		}
	}

	/**
	 * 
	 */
	onWatcherInterval()
	{
		this.update();

		if ( this.isFirstWatcherUpdate )
		{
			this.entityList.forEach( entity =>
			{
				entity.element.classList.add( "pos-ready" );
			} );

			this.isFirstWatcherUpdate = false;
		}
	}
	
	/**
	 * 
	 * @param {Event} event 
	 */
	onWindowResize( event )
	{
		if ( this.lastWindowWidth !== window.innerWidth )
		{
			this.update();
		}
	}

}

export default PositionManager;

/**
 * 
 */
class PositionEntity {

	/**
	 * 
	 * @type Object
	 */
	args = undefined;

	/**
	 * 
	 * @type HTMLElement
	 */
	element = undefined;

	/**
	 * 
	 * @type Number
	 */
	lastOffsetLeft = undefined;

	/**
	 * 
	 * @type Number
	 */
	lastReferenceWidth = undefined;

	/**
	 * 
	 * @type Number
	 */
	lastWidth = undefined;

	/**
	 * 
	 * @param {HTMLElement} element 
	 * @param {Object} args 
	 */
	constructor( element, args )
	{
		this.element = element;
		this.args = args;
	}

	/**
	 * 
	 */
	getReferenceWidth()
	{
		const referenceElement = ( this.args.referenceElement ) ? this.args.referenceElement : document.body;
		return referenceElement.clientWidth;
	}

	/**
	 * 
	 */
	update()
	{
		const referenceWidth = this.getReferenceWidth();

		if ( this.lastWidth === this.element.clientWidth && referenceWidth === this.lastReferenceWidth && this.lastOffsetLeft === this.element.offsetLeft ) return;
		
		switch ( this.args.x )
		{
			case 'center':
				WMUUtils.centerElement( this.element );
				break;	
		}

		this.lastWidth = this.element.clientWidth;
		this.lastReferenceWidth = referenceWidth;
	}
}